import { DateTime } from 'luxon';
// en-Gov isn't a real locale
function parseLanguage(languageTag) {
    if (languageTag === 'en-GOV')
        return 'en';
    return languageTag;
}
/**
 *
 * @param dateString - in the format of 'YYYY-MM-DD'
 * @param languageTag
 * @param formatOptions
 * @returns
 */
export const formatDate = (dateString, languageTag, formatOptions) => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
        throw new Error('Invalid date format. Expected YYYY-MM-DD');
    }
    const dateTime = DateTime.fromISO(dateString);
    if (!dateTime.isValid) {
        throw new Error('Invalid date provided');
    }
    return dateTime.toLocaleString(formatOptions, {
        locale: parseLanguage(languageTag),
    });
};
export const formatISODate = (dateISOString, languageTag, formatOptions) => {
    const dateTime = DateTime.fromISO(dateISOString);
    if (!dateTime.isValid) {
        throw new Error('Invalid ISO date provided');
    }
    return dateTime.toLocaleString(formatOptions, {
        locale: parseLanguage(languageTag),
    });
};
//# sourceMappingURL=date.js.map